module.exports = __webpack_public_path__ + "img/logo.d6c13feb.svg";